import React from 'react';

import dayjs from '~/timeInit';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';

import FieldHistoryBody from './FieldHistoryBody';
import { newestOfCountLabel } from './newestOfCountLabel';
import type { FieldHistoryEntry } from './types';

interface Props {
  backLabel: string;
  entries: Array<FieldHistoryEntry>;
  error?: Error | null;
  isLoading?: boolean;
  lastUpdatedAt?: string;
  onBack: () => void;
  title: string;
  totalCount?: number;
}

export default function FieldHistoryReport({
  backLabel,
  entries,
  error,
  isLoading,
  lastUpdatedAt,
  onBack,
  title,
  totalCount = entries.length,
}: Props) {
  const countLabel = newestOfCountLabel('item', entries.length, totalCount);

  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Typography variant="h5">{title}</Typography>
          {!isLoading && !error && (
            <Typography variant="body2" color="text.secondary">
              {countLabel} · Sorted by Date
              {lastUpdatedAt && ` · Updated ${dayjs(lastUpdatedAt).fromNow()}`}
            </Typography>
          )}
        </Box>
        <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
          {backLabel}
        </Button>
      </Stack>
      <Paper variant="outlined">
        <FieldHistoryBody entries={entries} error={error} isLoading={isLoading} />
      </Paper>
    </Stack>
  );
}
